/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordData
 */
export interface ChangePasswordData {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordData
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordData
     */
    password: string;
}

/**
 * Check if a given object implements the ChangePasswordData interface.
 */
export function instanceOfChangePasswordData(value: object): value is ChangePasswordData {
    if (!('currentPassword' in value) || value['currentPassword'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function ChangePasswordDataFromJSON(json: any): ChangePasswordData {
    return ChangePasswordDataFromJSONTyped(json, false);
}

export function ChangePasswordDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordData {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPassword': json['currentPassword'],
        'password': json['password'],
    };
}

export function ChangePasswordDataToJSON(json: any): ChangePasswordData {
    return ChangePasswordDataToJSONTyped(json, false);
}

export function ChangePasswordDataToJSONTyped(value?: ChangePasswordData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPassword': value['currentPassword'],
        'password': value['password'],
    };
}

